import React, { Fragment, useEffect } from "react";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
  useHistory
} from "react-router-dom";
import InitiateWebSocket from "src/Components/Custom/InitiateWebSocket/InitiateWebSocket";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import Loader from "src/Components/Shared/Loader/Loader";
import AboutContentEn from "src/Pages/About/AboutContentEn";
import AboutContentFr from "src/Pages/About/AboutContentFr";
import AboutPage from "src/Pages/About/AboutPage";
import AuthAboutPage from "src/Pages/About/AuthAboutPage";
import ContactUs from "src/Pages/ContactUs/ContactUs";
import AuthContactUs from "src/Pages/ContactUs/AuthContactUs";
import ContactUsEn from "src/Pages/ContactUs/ContactUsContent";
import DashboardPage from "src/Pages/Dashboard/DashboardPage";
import AuthFAQsPage from "src/Pages/FAQs/AuthFAQsPage";
import FAQsContentEn from "src/Pages/FAQs/FAQsContentEn";
import FAQsContentFr from "src/Pages/FAQs/FAQsContentFr";
import FAQsPage from "src/Pages/FAQs/FAQsPage";
import IntroPage from "src/Pages/Intro/IntroPage";
import LoginPage from "src/Pages/Login/LoginPage";
import AuthPrivacyPage from "src/Pages/Privacy/AuthPrivacyPage";
import PrivacyContentEn from "src/Pages/Privacy/PrivacyContentEn";
import PrivacyContentFr from "src/Pages/Privacy/PrivacyContentFr";
import PrivacyPage from "src/Pages/Privacy/PrivacyPage";
import Profile from "src/Pages/Profile/Profile";
import Settings from "src/Pages/Settings/Settings";
import SignupPage from "src/Pages/Signup/SignupPage";
import AuthTermsPage from "src/Pages/Terms/AuthTermsPage";
import TermsContentEn from "src/Pages/Terms/TermsContentEn";
import TermsContentFr from "src/Pages/Terms/TermsContentFr";
import TermsPage from "src/Pages/Terms/TermsPage";
import AppStateHandler, {
  useAppState,
} from "src/StateHandlers/AppStateHandler";
import AboutContentAr from "src/Pages/About/AboutContentAr";
import FAQsContentAr from "src/Pages/FAQs/FAQsContentAr";
import TermsContentAr from "src/Pages/Terms/TermsContentAr"
import PrivacyContentAr from "src/Pages/Privacy/PrivacyContentAr"
import ContactUsContent from "src/Pages/ContactUs/ContactUsContent";

function AppRouter() {
  const [{ loggedIn, loading }] = useAppState();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const history = useHistory();
  useEffect(() => {
    AppStateHandler.checkUserLogin();
  }, []);

  return (
    <Fragment>
      {loggedIn ? (
        <>
          <Loader visible={loading} />
          <InitiateWebSocket />
          <Router>
            <Switch>
              <Route exact path="/my-profile">
                <Profile />
              </Route>
              <Route exact path="/settings">
                <Settings />
              </Route>
              <Route exact path="/messages">
                <DashboardPage />
              </Route>
              <Route exact path="/messages/:id">
                <DashboardPage />
              </Route>
              <Route exact path="/bookmarks">
                <DashboardPage />
              </Route>
              <Route exact path="/bookmarks/:id">
                <DashboardPage />
              </Route>
              <Route exact path="/my-posts">
                <DashboardPage />
              </Route>
              <Route exact path="/my-posts/:id">
                <DashboardPage />
              </Route>
              <Route exact path="/hidden-posts">
                <DashboardPage />
              </Route>
              <Route exact path="/hidden-posts/:id">
                <DashboardPage />
              </Route>
              <Route exact path="/sales">
                <DashboardPage />
              </Route>
              <Route exact path="/sales/:id">
                <DashboardPage />
              </Route>
              <Route exact path="/groups">
                <DashboardPage />
              </Route>
              <Route exact path="/groups/:id">
                <DashboardPage />
              </Route>
              <Route exact path="/groups/:id/:postId">
                <DashboardPage />
              </Route>
              <Route exact path="/business">
                <DashboardPage />
              </Route>
              <Route exact path="/business/:id">
                <DashboardPage />
              </Route>
              <Route exact path="/home">
                <DashboardPage />
              </Route>
              <Route exact path="/home/:id">
                <DashboardPage />
              </Route>
              <Route exact path="/about">
                <AuthAboutPage />
              </Route>
              <Route exact path="/faq">
                <AuthFAQsPage />
              </Route>
              <Route exact path="/terms-and-condition">
                <AuthTermsPage />
              </Route>
              <Route exact path="/privacy-policy">
                <AuthPrivacyPage />
              </Route>
              <Route exact path="/contact-us">
                <AuthContactUs />
              </Route>
              <Redirect from="/" to="/home" />
            </Switch>
          </Router>
        </>
      ) : (
          <Router>
            <Switch>
              <Route exact path="/about">
                <AboutPage />
              </Route>
              <Route exact path="/about-en">
                <AboutContentEn />
              </Route>
              <Route exact path="/about-fr">
                <AboutContentFr />
              </Route>
              <Route exact path="/about-ar">
                <AboutContentAr />
              </Route>
              <Route exact path="/faq">
                <FAQsPage />
              </Route>
              <Route exact path="/faq-en">
                <FAQsContentEn />
              </Route>
              <Route exact path="/faq-fr">
                <FAQsContentFr />
              </Route>
              <Route exact path="/faq-ar">
                <FAQsContentAr />
              </Route>
              <Route exact path="/terms-and-condition">
                <TermsPage />
              </Route>
              <Route exact path="/terms-and-condition-en">
                <TermsContentEn />
              </Route>
              <Route exact path="/terms-and-condition-fr">
                <TermsContentFr />
              </Route>
              <Route exact path="/terms-and-condition-ar">
                <TermsContentAr /> 
              </Route>
              <Route exact path="/privacy-policy">
                <PrivacyPage />
              </Route>
              <Route exact path="/privacy-policy-en">
                <PrivacyContentEn />
              </Route>
              <Route exact path="/privacy-policy-fr">
                <PrivacyContentFr />
              </Route>
              <Route exact path="/privacy-policy-ar">
                <PrivacyContentAr />
              </Route>
              <Route exact path="/contact-us">
                <ContactUs />
              </Route>
              <Route exact path="/contact-us-en">
              <ContactUsContent locale="en" />
              </Route>
              <Route exact path="/contact-us-fr">
              <ContactUsContent locale="fr" />
              </Route>
              <Route exact path="/contact-us-ar">
                <ContactUsContent locale="ar" />
                </Route>
              <Route exact path="/login">
                <LoginPage />
              </Route>
              <Route exact path="/signup">
                <SignupPage />
              </Route>
              <Route exact path="/welcome">
                <IntroPage />
              </Route>
              <Redirect from="/" to="/welcome" />
            </Switch>
          </Router>
        )}
    </Fragment>
  );
}

export default AppRouter;
